import { useCallback, useState } from 'react';

const initialFilter = {
  categories: [],
  providers: []
};

export const useSearchFilter = (handlePageChange) => {
  const [filterState, setFilterState] = useState(initialFilter);

  const applyFilter = useCallback(
    (filterKey, filterValues) => {
      setFilterState((prevFilter) => ({
        ...prevFilter,
        [filterKey]: filterValues
      }));
      if (handlePageChange) {
        handlePageChange(1);
      }
    },
    [setFilterState, handlePageChange]
  );
  const resetFilter = useCallback(
    (filterKey) => {
      setFilterState((prevFilter) => ({ ...prevFilter, [filterKey]: [] }));
      if (handlePageChange) {
        handlePageChange(1);
      }
    },
    [setFilterState, handlePageChange]
  );
  const resetAllFilters = useCallback(() => {
    setFilterState(initialFilter);
    if (handlePageChange) {
      handlePageChange(1);
    }
  }, [setFilterState, handlePageChange]);

  return {
    applyFilter,
    resetFilter,
    resetAllFilters,
    filterState
  };
};
